function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
var Label = function Label(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    _ref$info = _ref.info,
    info = _ref$info === void 0 ? null : _ref$info,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showInfo = _useState2[0],
    setShowInfo = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    forceOpen = _useState4[0],
    setForceOpen = _useState4[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "label-text ".concat(className),
    style: style
  }, /*#__PURE__*/React.createElement("span", null, label, required && /*#__PURE__*/React.createElement("b", null, "*")), info && /*#__PURE__*/React.createElement("div", {
    className: "label-text__info ".concat(forceOpen && 'blue'),
    onMouseEnter: function onMouseEnter() {
      if (forceOpen) return;
      setShowInfo(true);
    },
    onMouseLeave: function onMouseLeave() {
      if (forceOpen) return;
      setShowInfo(false);
    },
    onClick: function onClick() {
      return setForceOpen(!forceOpen);
    }
  }, /*#__PURE__*/React.createElement(FaInfoCircle, null), (forceOpen || showInfo) && /*#__PURE__*/React.createElement("div", {
    className: "label-text__info--bubble",
    dangerouslySetInnerHTML: {
      __html: info
    }
  })));
};
export default Label;